<!-- 工作在探见 -->
<template>
  <div class="workInTanjian">
    <div class="banner">
      <img src="../../assets/staffDevelopment/workInTanjian/工作在探见.png" alt="">
    </div>
    <div class="main">
      <div class="title">相信信念的力量</div>
      <p class="text">
        以丰富多彩的活动，深入人心的文化传承，不断成长的成长体系，将文化的信念与信仰不断传承，在这里，每个人都能经由企业文化找到个人梦想与企业使命的连接，每天的努力工作有价值、有意义，每个人都能焕发出鲜活的热情。
      </p>
      <div class="card">
        <div class="card-warp" :style="{ left: cardWarpLeft + 'px' }">
          <div class="card-item">
            <img src="../../assets/staffDevelopment/workInTanjian/满天星学堂.jpg" alt="">
            <div class="describe" :style="{ width: 0 == cardIndex ? '240px' : '0px' }">
              <div class="title">满天星学堂</div>
              <div class="text">
                成立于2023年，是探见为员工打造专业的成长发展之路，为企业打造学习型组织的崭新里程碑。我们通过设计职业发展通道和对应的完善培训体系，努力成为探见员工的成长顾问与业务团队的发展伙伴，为探见的现在和未来培养人才。
              </div>
              <!-- <div class="lookMore">查看更多——></div> -->
            </div>
          </div>
          <div class="card-item">
            <img src="../../assets/staffDevelopment/workInTanjian/探见读书日.jpg" alt="">
            <div class="describe" :style="{ width: 1 == cardIndex ? '240px' : '0px' }">
              <div class="title">探见读书会</div>
              <div class="text">
                成立于2021年疫情期间，是探见为管理层及以上企业领导者打造的学习组织。探见的职业经理人一定是终身学习者，读书会每月推荐一本指定书目，在同一主题下进行思想的碰撞，内容从宏观到微观，从经典经营管理案例、商业理论、大师课到探见真实的每一天、每一步、每一个决策，真理越辩越明，逐步统一认知，增加默契，达成共识。
              </div>
              <!-- <div class="lookMore">查看更多——></div> -->
            </div>
          </div>
          <div class="card-item">
            <img src="../../assets/staffDevelopment/workInTanjian/文化日.jpg" alt="">
            <div class="describe" :style="{ width: 2 == cardIndex ? '240px' : '0px' }">
              <div class="title">探见文化日</div>
              <div class="text">
                每年的6月25日，是探见的生日，也是所有探见人的节日。这一天，全体探见员工都会穿着由探见人自己设计的特色文化衫，摆出创意造型拍合影，共同庆祝公司的生日，将文化不断传承下去。
              </div>
              <!-- <div class="lookMore">查看更多——></div> -->
            </div>
          </div>
          <div class="card-item">
            <img src="../../assets/staffDevelopment/workInTanjian/年会.jpg" alt="">
            <div class="describe" :style="{ width: 3 == cardIndex ? '240px' : '0px' }">
              <div class="title">探见年会</div>
              <div class="text">
                自探见创立以来，每年年底，全体员工欢聚一堂，凝聚才华与激情创作出一个个精彩的节目，增加同事之间的感情，同时激励员工在新的一年里再接再厉。

              </div>
              <!-- <div class="lookMore">查看更多——></div> -->
            </div>
          </div>
          <div class="card-item">
            <img src="../../assets/staffDevelopment/workInTanjian/员工大会.jpg" alt="">
            <div class="describe" :style="{ width: 4 == cardIndex ? '240px' : '0px' }">
              <div class="title">员工大会</div>
              <div class="text">
                每年年底举行的员工大会，和新年晚会都是探见年度最重要的盛会，员工大会上，向员工传递公司战略、业务布局与管理思路，并表彰优秀团队。
              </div>
              <!-- <div class="lookMore">查看更多——></div> -->
            </div>
          </div>
          <div class="card-item">
            <img src="../../assets/staffDevelopment/workInTanjian/文体活动.jpg" alt="">
            <div class="describe" :style="{ width: 5 == cardIndex ? '240px' : '0px' }">
              <div class="title">文体协会</div>
              <div class="text">
                为关爱员工健康，丰富业余生活，探见成立了舞蹈、音乐、篮球、足球、羽毛球、桌游社等文体协会。
              </div>
              <!-- <div class="lookMore">查看更多——></div> -->
            </div>
          </div>
        </div>
      </div>
      <div class="dot">
        <img class="left" src="../../assets/home/箭头左-50x50px.png" @click="prev" />
        <img class="right" src="../../assets/home/箭头右-50x50px.png" @click="next" />
      </div>
    </div>
  </div>
</template>

<script>
import { bannerList } from '@/api/api'
export default {
  data() {
    return {
      imgList: [],
      cardIndex: 0,
      cardWarpLeft: 0,
      timer: null,
    };
  },
  mounted() {
    bannerList({ type: 1 }).then(res => {
      //console.log(res)
      if (res.code == 1) {

        this.imgList = res.data;
        // console.log(this.imgList);
      }
    })
    this.timer = setInterval(() => {
      this.next()
    }, 5000);
  },
  destroyed() {
    clearInterval(this.timer)
  },
  methods: {
    prev() {
      this.cardIndex--
      if (this.cardIndex < 0) {
        this.cardIndex = 5
      }
      this.cardWarpLeft = this.cardIndex < 3 ? 0 : -((this.cardIndex - 2) * 260)
    },
    next() {
      this.cardIndex++
      if (this.cardIndex >= 6) {
        this.cardIndex = 0
      }
      this.cardWarpLeft = this.cardIndex < 3 ? 0 : -((this.cardIndex - 2) * 260)
    },
  },
};
</script>

<style lang="scss" scoped>
.workInTanjian {
  width: 100%;

  .banner {
    width: 100%;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .main {
    width: 1200px;
    margin: 0 auto;

    .title {
      text-align: left;
      font-size: 24px;
      color: rgb(35, 44, 223);
      margin-top: 80px;
      font-family: 'BlackFont';
    }

    .text {
      font-size: 16px;
      margin-top: 20px;
    }

    .card {
      margin-top: 30px;
      position: relative;
      height: 400px;
      overflow: hidden;

      .card-warp {
        position: absolute;
        // width: 100%;
        display: flex;
        transition: all 0.5s;

        .card-item {
          height: 386px;
          display: flex;
          background-color: rgb(35, 44, 223);
          border-radius: 12px;
          margin-right: 20px;


          img {
            width: 240px;
            border-radius: 12px;
            object-fit: cover;
          }

          .describe {
            // width: 0px;
            overflow: hidden;
            transition: all 0.5s;
            color: #fff;

            .title {
              width: 200px;
              margin: 40px 20px 20px 25px;
              color: #fff;
              font-size: 24px;
            }

            .text {
              width: 160px;
              margin: 20px 20px 20px 25px;
              font-size: 12px;
            }

            .lookMore {
              width: 100px;
              margin-left: 70px;
              margin-top: 160px;
              font-size: 12px;
              border: 1px solid #fff;
              background-color: transparent;
            }
          }
        }
      }
    }

    .dot {
      margin-top: 10px;
      margin-bottom: 100px;
      padding-right: 10px;
      width: 100%;
      display: flex;
      justify-content: flex-end;

      img {
        background-color: #efefef;
        cursor: pointer;
        width: 30px;
        height: 30px;
        border-radius: 50%;
      }

      .right {
        margin-left: 50px;
      }
    }
  }
}
</style>